export default function Outer() {
    return (
        <div className="outer">
            <div className="dot red" />
            <div className="dot amber" />
            <div className="dot green" />
        </div>
    );
}
